import { FormConfig, PageConf } from '@topdanmark-onlinesolutions/claim-form-types';

export const getPageConfFromPageId = (formConfig: FormConfig, pageId: string): PageConf | undefined => {
    const pageConf = formConfig.pages.find((page) => page.pageId === pageId);

    return pageConf;
};
